import { NetworkLogs } from '../models/networkLogs'

export interface NetworkLogsStateType {
  networkLogs: NetworkLogs[]
  networkLog: NetworkLogs | null
}

const NetworkLogsState: () => NetworkLogsStateType = () => ({
  networkLogs: [],
  networkLog: null,
})

export default NetworkLogsState
